import { useTranslation } from 'react-i18next';

export default function About() {
  const { t } = useTranslation();

  return (
    <main className="w-full">
      {/* Hero */}
      <section className="relative h-[280px] md:h-[360px] w-full overflow-hidden">
        <div className="absolute inset-0">
          <img
            alt="关于88健康知识网"
            title="关于88健康知识网"
            className="w-full h-full object-cover object-top"
            src="https://readdy.ai/api/search-image?query=Peaceful%20natural%20wellness%20scene%20with%20soft%20green%20botanical%20elements%20and%20warm%20amber%20sunlight%20gentle%20abstract%20composition%20health%20harmony%20concept%20minimalist%20clean%20design%20soft%20natural%20lighting%20organic%20aesthetic&width=1600&height=600&seq=about-hero-001&orientation=landscape"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40" />
        <div className="relative z-10 flex flex-col items-center justify-center h-full px-4 md:px-8 text-center w-full">
          <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-3">
            {t('aboutTitle')}
          </h1>
          <p className="text-white/70 text-sm md:text-base max-w-lg">
            {t('aboutCompany')}
          </p>
        </div>
      </section>

      {/* Company info */}
      <section className="w-full py-14 md:py-20 bg-background-50 px-4 md:px-8">
        <div className="max-w-5xl mx-auto">
          {/* Founder */}
          <div className="bg-background-100 rounded-2xl p-6 md:p-10 flex flex-col md:flex-row gap-6 md:gap-10 items-center mb-10 md:mb-14">
            <div className="w-36 h-36 md:w-44 md:h-44 rounded-2xl overflow-hidden flex-shrink-0 shadow-sm">
              <img
                alt="周团长 诺家健康创始人"
                title="周团长 诺家健康创始人"
                className="w-full h-full object-cover object-top"
                src="https://static.readdy.ai/image/b6ede0cab72a069c40077ea5d817c4eb/f0f010666bde19542e1ee651bb1c90fb.jpeg"
              />
            </div>
            <div className="flex-1 text-center md:text-left">
              <p className="text-xs tracking-widest uppercase text-foreground-400 mb-2">
                Founder Story
              </p>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-tight mb-1">
                {t('founderName')}
              </h2>
              <p className="text-sm text-primary-600 font-medium mb-4">
                从<span className="text-accent-500 font-bold">36种疾病</span>到<span className="text-primary-500 font-bold">健康管理者</span>
              </p>
              <div className="space-y-2.5 text-sm text-foreground-700 leading-relaxed">
                <p>
                  大家好，我是周团长，出生于台湾，祖籍浙江。自己从小到大生过36种疾病，24岁时还得过急性白血症，鬼门关前走一回，因此长期关注健康管理、营养补充、生活方式调整与家庭日常保养。
                </p>
                <p>
                  我早年曾在台湾创业10年，2007年加入富士康集团服务11年，曾担任事业单位高阶主管。2017年退休后，担任杭州一家产业基金管理公司副总裁至2019年。2022年起系统地研究健康管理与营养学，于2024年12月取得中国高级营养师与高级健康管理师证书，2025年3月考取中国人社部二级营养师执照。
                </p>
              </div>
              <div className="flex flex-wrap justify-center md:justify-start gap-2 mt-5">
                <span className="inline-flex items-center gap-1 bg-accent-100 text-accent-800 px-3 py-1 rounded-full text-xs font-medium">
                  <i className="ri-shield-check-line text-xs" />
                  高级营养师
                </span>
                <span className="inline-flex items-center gap-1 bg-primary-100 text-primary-800 px-3 py-1 rounded-full text-xs font-medium">
                  <i className="ri-heart-pulse-line text-xs" />
                  高级健康管理师
                </span>
                <span className="inline-flex items-center gap-1 bg-secondary-100 text-secondary-800 px-3 py-1 rounded-full text-xs font-medium">
                  <i className="ri-award-line text-xs" />
                  二级营养师执照
                </span>
              </div>
            </div>
          </div>

          {/* Company intro */}
          <div className="bg-background-100 rounded-2xl p-6 md:p-10 mb-10 md:mb-14">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-building-line text-primary-600 text-lg" />
              </div>
              <div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-4">
                  {t('aboutCompany')}
                </h2>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                  {t('companyIntro')}
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm text-foreground-600">
                  <div className="flex items-start gap-2.5">
                    <span className="w-1.5 h-1.5 rounded-full bg-primary-500 flex-shrink-0 mt-2" />
                    <span><strong className="text-foreground-900">{t('aboutServiceInfo')}</strong> — {t('aboutServiceInfoDesc')}</span>
                  </div>
                  <div className="flex items-start gap-2.5">
                    <span className="w-1.5 h-1.5 rounded-full bg-primary-500 flex-shrink-0 mt-2" />
                    <span><strong className="text-foreground-900">{t('aboutServiceHealth')}</strong> — {t('aboutServiceHealthDesc')}</span>
                  </div>
                  <div className="flex items-start gap-2.5">
                    <span className="w-1.5 h-1.5 rounded-full bg-primary-500 flex-shrink-0 mt-2" />
                    <span><strong className="text-foreground-900">{t('aboutServiceContact')}</strong> — {t('aboutServiceContactDesc')}</span>
                  </div>
                  <div className="flex items-start gap-2.5">
                    <span className="w-1.5 h-1.5 rounded-full bg-primary-500 flex-shrink-0 mt-2" />
                    <span><strong className="text-foreground-900">{t('aboutServiceShipping')}</strong> — {t('aboutServiceShippingDesc')}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Important notice */}
          <div className="bg-background-100 rounded-2xl p-6 md:p-10">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-full bg-accent-500 flex items-center justify-center flex-shrink-0">
                <i className="ri-alert-line text-white text-lg" />
              </div>
              <div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-4">
                  {t('importantNotice')}
                </h2>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  {t('noMedicalAdvice')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}